// =========================
// 404 PAGE VIEW
// =========================
import App from './../../App';
import { html, render } from 'lit-html';
import { gotoRoute } from './../../Router';
import Auth from './../../Auth';

// This is the FourOFourView class that handles the 404 page
// This is used when the user tries to access a page that doesn't exist
class FourOFourView {
  // This method initializes the view
  init() {
    console.log('FourOFourView.init');
    document.title = '404 | Page Not Found';
    this.render();
  }

  render() {
    const template = html`
      <div class="four-o-four">
        <div class="four-o-four-content">
          <h1>Oops!</h1>
          <p>We couldn't find the page you were looking for.</p>
          <sl-button
            variant="success"
            @click=${() => gotoRoute(Auth.isLoggedIn() ? '/feed' : '/')}
          >
            Back to Home
          </sl-button>
        </div>
      </div>
    `;
    render(template, App.rootEl);
  }
}

export default new FourOFourView();
